/*
 *  Product Carousel
 *    Scripts for the product carousel utilising Slick.
 *
 *
 *  Version:
 *    1.0.0 - 2020/07/13
 */

import $ from 'jquery';

import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { ON_VARIANT_CHANGE } from './../../objects/swatch/Swatch';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-product-carousel-container]';
export const CAROUSEL_SELECTOR = '[data-product-carousel]';
export const CAROUSEL_NAVIGAITON_SELECTOR = '[data-product-carousel-navigation]';
export const PRODUCT_JSON_SELECTOR = '[data-product-json]';
export const PRODUCT_IMAGE_SELECTOR = '[data-product-template-carousel-image]';
export const PRODUCT_THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';
export const CAROUSEL_DOTS_SELECTOR = '[data-product-carousel-dots]';
export const CAROUSEL_DOT_SELECTOR = '[data-product-carousel-dot]';
export const PRODUCT_VIDEO_ID = 'product-carousel-video';
export const PRODUCT_VIDEO_SELECTOR = '[data-product-carousel-video]';

//Attrs
export const THUMBNAIL_INDEX = 'data-index';
export const PRODUCT_INITIAL_VARIANT = 'data-initial-variant-id';
export const PRODUCT_THUMBNAIL_COUNT = 'data-thumbnail-count';

export const THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';

export const CLASS_ACTIVE = 'is-active';

export class ProductCarousel extends CarouselSection {
  constructor(container) {
    super(container);

    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.navigation = container.find(CAROUSEL_NAVIGAITON_SELECTOR);
    this.productThumb = container.find(PRODUCT_THUMBNAIL_SELECTOR);
    this.thumbCount = this.productThumb.length;
    this.navigationDots = container.find(CAROUSEL_DOTS_SELECTOR);
    this.productVideo = document.getElementById(PRODUCT_VIDEO_ID);

    //JSON Data
    this.jsonElement = $(PRODUCT_JSON_SELECTOR);

    this.slick = this.initCarousel(this.carouselContainer);

    //Events
    $(document).on('click', THUMBNAIL_SELECTOR, (e) => this.onThumbnailClick(e));
    container.on('click', CAROUSEL_DOT_SELECTOR, (e) => this.onDotClick(e));
    $(document).on(ON_VARIANT_CHANGE, (e,variant) => this.onVariantChange(variant));

    container.on('beforeChange', CAROUSEL_SELECTOR, (e, slick, currentSlide, nextSlide) => {
      this.goToThumb(nextSlide);
    });
    container.on('beforeChange', (e, slick, currentSlide, nextSlide) => this.onSlickChange(e, slick, currentSlide, nextSlide));

    this.initDotsCarousel(); //Initialise Slick dots

    this.initNavCarousel(); //Initialise navigation slick

    // this.initVariantImage(); //Initialise variant image

    $(window).on('resize', () => this.initNavCarousel());
  }

  initDotsCarousel() {
    this.dotsSlick = this.navigationDots.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      focusOnSelect: false,
      centerMode: false,
      draggable: false,
      adaptiveHeight: false,
      swipeToSlide: true
    });
    this.navigationDots.find('[data-slick-index="0"]').addClass(CLASS_ACTIVE);
  }

  initNavCarousel() {
    const slideWidth = 110;
    if(this.navigation.hasClass('slick-initialized')) {
      this.navigation.slick('unslick'); 
    }

    let navCarouselContainerWidth = this.navigation.outerWidth();
    // don't do anything if the container is too small
    if(navCarouselContainerWidth < slideWidth) {
      // console.log('containerwidth 0');
      return;
    }

    let navCarouselThumbsWidth = 0;
    this.productThumb.each(function() { 
      navCarouselThumbsWidth += slideWidth;
    });
    
    // console.log(`navCarouselContainerWidth: ${navCarouselContainerWidth}`);
    // console.log(`navCarouselThumbsWidth: ${navCarouselThumbsWidth}`);

    // don't slick if there is enough space to show all slides
    if(navCarouselContainerWidth > navCarouselThumbsWidth) {
      // console.log('enough space for slides, unslicking');
      return;
    }

    // show enough slides to keep the original slide size
    let navSlidesToShow = navCarouselContainerWidth / slideWidth;

    // console.log(`Show ${navCarouselContainerWidth} / ${slideWidth} slides`);
    // console.log('init slick');
    this.navigationSlick = this.navigation.slick({
      mobileFirst: true,
      slidesToShow: navSlidesToShow,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      draggable: true,
      adaptiveHeight: false,
      swipeToSlide: true
    });
  }

  initVariantImage() {
    //Set the thumb and main image on page load
    let initial = this.productThumb.attr(PRODUCT_INITIAL_VARIANT);
    let thumbTarget = $(PRODUCT_THUMBNAIL_SELECTOR+'[data-image-id="'+initial+'"]');
    let mainTarget = $(PRODUCT_IMAGE_SELECTOR+'[data-image-id="'+initial+'"]');

    if(!thumbTarget.length || !mainTarget.length) return;

    // Check that the thumbnail carousel exists
    if(this.navigationSlick != undefined) {
      this.navigationSlick.slick('slickGoTo', parseInt(thumbTarget.attr(THUMBNAIL_INDEX)), false);
    }
    this.slick.slick('slickGoTo', parseInt(mainTarget.attr(THUMBNAIL_INDEX)), false);
  }

  onSlickChange(e, slick, currentSlide, nextSlide) {
    this.dotsSlick.slick('slickGoTo', nextSlide, false);
    this.dotsSlick.find(`.slick-slide`).removeClass(CLASS_ACTIVE);
    this.dotsSlick.find(`[data-slick-index="${nextSlide}"]`).addClass(CLASS_ACTIVE);
  }

  optionOverrides() {
    return {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      fade: true,
      cssEase: 'linear',
      dots: false,
      adaptiveHeight: true,
      swipe: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.medium - 1,
          settings: { slidesToShow: 1, slidesToScroll: 1, dots: false, arrows: false, infinite: true }
        }
      ]
    }
  }

  onDotClick(e) {
    let self = $(e.currentTarget);
    let index = self.attr('data-index');
    this.goToSlide(index);
  }

  //Thumbnail Navigation
  onThumbnailClick(e) {
    let self = $(e.currentTarget);
    let index = self.attr('data-index');
    this.goToSlide(index);
  }

  onVariantChange(variant) {
    if(typeof variant === typeof undefined) return;

    //Set our image, use the one for this variant, if not use default.
    if(!variant.featured_image) return;
    let imageId = variant.featured_image.id;
    let target = $(PRODUCT_THUMBNAIL_SELECTOR+'[data-image-id='+imageId+']');
    if(!target.length) return;
    if(this.thumbCount > 5) this.navigationSlick.slick('slickGoTo', parseInt(target.attr(THUMBNAIL_INDEX)));
    target.trigger('click');
  }

  goToSlide(index) {
    this.carouselContainer.slick('slickGoTo', index);
    this.setActiveImage(index);
  }

  goToThumb(nextSlide) {
    if(this.navigation.hasClass('slick-initialized')) {
      this.navigation.slick('slickGoTo', nextSlide);
    }
    this.setActiveImage(nextSlide);
  }

  setActiveImage(index) {
    $(THUMBNAIL_SELECTOR).removeClass(CLASS_ACTIVE);
    $(`${THUMBNAIL_SELECTOR}[data-index="${index}"]`).addClass(CLASS_ACTIVE);
  }
}

register(CONTAINER_SELECTOR, ProductCarousel);